import {get,post} from '../utils/request'

// 获取学校的年级、班级、学生下拉列表
export const getCascade = (data)=>post('https://yingde_api.ydassess.com/health/school/cascade/students',data)

export const getCascadeTwo = (params)=>get('/api/personnel/tree/gradeClass/student',params)

// 获取省市区下拉列表
export const provinceList =(params) => get('/api/province/list/school',params)

// 根据省市区获取集团子校、普通校班级列表
export const provinceToSchool = (params) => get('/api//school/list/tree/all',params)

// 获取年级、班级级联列表  （/教师端根据教师id查询）
export const gradeAndClass = (params) => get('https://yingde_api.ydassess.com/courses/teacher/cascade/grade/class',params)

// 获取课程下拉列表
export const projectList = (params) => get('https://yingde_api.ydassess.com/courses/public/attrs',params)


// WEBPACK FOOTER //
// ./src/api/select.js